import { Component, computed, inject, input, resource } from '@angular/core';
import { BrugerNotifikationApi } from '@features/brugere/bruger-notifikationer/bruger-notifikation.api';

@Component({
  selector: 'app-bruger-notifikationer',
  imports: [],
  templateUrl: './bruger-notifikationer.component.html',
  styleUrl: './bruger-notifikationer.component.css',
})
export class BrugerNotifikationerComponent {
  brugerId = input.required<number>();
  brugerNotifikationApi = inject(BrugerNotifikationApi);

  notifikationer = computed(() => {
    const apiResponse = this.data.value();
    return apiResponse?.data || [];
  });

  data = resource({
    params: () => this.brugerId(),
    loader: async ({ params, abortSignal }) => {
      return await this.brugerNotifikationApi.getList(
        {
          filter: JSON.stringify({
            brugerId: params,
          }),
        },
        abortSignal
      );
    },
  });
}
